export default "/fonts/poppins-v9-latin-regular.woff?e78693354999fe502e16d2a47bf68e1d";